<template>
  <div v-if="selectedAccount" class="card-wrapper-box">
    {{ this.xtz }}
    <v-card
      class="elevation-0 rounded-0 deposit-form-card"
      :class="$vuetify.theme.dark ? 'blue-darken-2' : 'white-lighten-1'"
    >
      <div class="ribbon"><span>To</span></div>
      <v-card-actions>
        <div class="trade-status">
          <div>
            <v-icon class="teal-text-lighten-1">mdi-signal</v-icon>
          </div>
          <div class="trade-number">
            <span
              >MT5 - {{ filteredTradingAccount?.account_type_display }}</span
            >
            <span>{{ filteredTradingAccount?.trading_account_no }}</span>
          </div>
        </div>
      </v-card-actions>
      <v-card-actions>
        <div class="value-trades">
          <span>Balance</span>
          <span>{{ Number(filteredTradingAccount?.Balance / filteredTradingAccount?.usd_rate)?.toFixed(2) }}</span>
        </div>
        <v-spacer></v-spacer>
        <div class="value-trades">
          <span>MT5 Currency</span>
          <span>{{ filteredTradingAccount?.usd_rate == 1 ? 'USD' : 'CENT' }}</span>
        </div>
      </v-card-actions>
      <v-card-actions>
        <v-sheet :class="$vuetify.theme.dark ? 'transparent ' : 'transparent'">
          <div>
            <apexChart
              width="100%"
              height="95px"
              type="line"
              :options="options"
              :series="[{ name: 'Equity/Balance', data: seriesData }]"
            >
            </apexChart>
          </div>
        </v-sheet>
      </v-card-actions>
      <v-card-actions>
        <div class="currency-leverage">
          <span>Equity</span>
          <span>{{ Number(filteredTradingAccount?.Equity / filteredTradingAccount?.usd_rate)?.toFixed(2) }}</span>
        </div>
        <v-spacer></v-spacer>
        <div class="currency-leverage">
          <span>Leverage</span>
          <span>{{ filteredTradingAccount?.MarginLeverage }}:1</span>
        </div>
      </v-card-actions>
      <v-card-actions>
        <div class="balance-equity">
          <span>Free Margin</span>
          <span>{{
            Number(filteredTradingAccount?.MarginFree / filteredTradingAccount?.usd_rate)?.toFixed(2)
          }}</span>
        </div>
        <v-spacer></v-spacer>
        <div class="balance-equity">
          <span class="text-end">Acc. Type</span>
          <span>{{ filteredTradingAccount?.account_type_display || "N/A" }}</span>
        </div>
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
import { TRADINGACCOUNTSTOTRANSFER__ACTIONS } from "@/store/action-types";
import { mapState, mapActions } from "vuex";

export default {
  data() {
    return {
      e1: 1,
      selectedTradingAccount: null,
      selectedAccount: null,
      options: {
        chart: {
          type: "line",
          toolbar: {
            show: false,
          },
        },
        xaxis: {
          labels: {
            show: false,
          },
          axisTicks: {
            show: false,
          },
          axisBorder: {
            show: false,
          },
        },
        yaxis: {
          labels: {
            show: false,
          },
        },
        grid: {
          show: false,
        },
        stroke: {
          width: 2,
        },
        dataLabels: {
          enabled: false,
        },
        colors: ["#3A648E"],
      },
      filteredTradingAccount: {},
    };
  },

  created() {
    this.selectedAccount = this.$route.query.id;
    this.filterTradingAccount();
  },

  watch: {
    "$route.query.id": function (newId) {
      this.selectedAccount = newId;
      this.filterTradingAccount();
    },
  },

  computed: {
    ...mapState("tradingaccounts", ["tradingAccounts"]),
    seriesData() {
      if (!this.filteredTradingAccount) return [];

      const balance = Number(this.filteredTradingAccount.Balance) || 0;
      const equity = Number(this.filteredTradingAccount.Equity) || 0;

      if (balance > equity) {
        return [50, 20, 15, 10, -10, -15, -20];
      } else if (balance < equity) {
        return [-20, -15, -10, 10, 15, 20, 50];
      } else if (balance === equity) {
        return [45, 47, 43, 45, 43, 47, 45];
      } else {
        return [0, 0];
      }
    },
  },

  methods: {
    ...mapActions("tradingaccounts", [
      TRADINGACCOUNTSTOTRANSFER__ACTIONS.TRADINGACCOUNTSTOTRANSFER,
    ]),
    filterTradingAccount() {
      if (this.selectedAccount) {
        this.filteredTradingAccount =
          this.tradingAccounts.find(
            (account) => account.id == this.selectedAccount
          ) || {};
      } else {
        this.filteredTradingAccount = {};
      }
    },
  },

  async mounted() {
    await this[TRADINGACCOUNTSTOTRANSFER__ACTIONS.TRADINGACCOUNTSTOTRANSFER]();
  },
};
</script>
